import store from "../redux/store/Store";

export const userTypes = () => {
  return store?.store.getState().constantsDetail.constants.core.UserMeta.choices
    .type;
};

export const userGenders = () => {
  return store.store.getState().constantsDetail.constants.core.UserMeta.choices
    .gender;
};

export const pointTypes = () => {
  return store.store.getState().constantsDetail.constants.core.Point.choices
    .type;
};

export const educationTypes = () => {
  return store.store.getState().constantsDetail.constants.core.Education.choices
    .type;
};

export const educationGender = () => {
  return store.store.getState().constantsDetail.constants.core.Education.choices
    .gender;
};
export const paymentStatus = () => {
  return store.store.getState().constantsDetail.constants.accounting.Payment
    .choices.status;
};

export const onlinePaymentStatus = () => {
  return store.store.getState().constantsDetail.constants.accounting
    .OnlinePayment.choices.status;
};

export const getCitiesKeyById = () => {
  let city = store.store.getState().constantsDetail.constants.other.city;
  const cityObject = [];
  for (let item of city) {
    cityObject[item.id] = item;
  }
  return cityObject;
};

export const getCitiesKeyByState = () => {
  let city = store.store.getState().constantsDetail.constants.other.city;
  const cityObject = [];
  for (let item of city) {
    cityObject[item.ostan] = item;
  }
  return cityObject;
};

export const getStatesKeyById = () => {
  const state = store.store.getState().constantsDetail.constants.other.state;
  const stateObj = [];
  for (let item of state) {
    stateObj[item.id] = item;
  }
  return stateObj;
};

export const getStateByID = (requestedStateID) => {
  const states = store.store.getState().constantsDetail.constants.other.state;
  const stateObj = states.find(({ id }) => id === requestedStateID);
  const { ostan } = stateObj;
  return ostan;
};
